import * as C from "../Vars/charts";
import Helper from "./Helper.js";
import ChartTableHandler from "./ChartTableHandler";

class ChartDisplayHandler {
  constructor() {
    this.renderChart();
    this.handleSwapVisibility();
    this.handleInactiveCats();
  }

  renderChart(seriesArr, cats) {
    C.chartRenderCounter = C.chartRenderCounter + 1;
    if (C.chartRenderCounter == 1) {
      C.currentInactiveSeriesArray = [];
      C.currentInactiveCatsArray = [];
    }
    // console.log('render counter is ' + C.chartRenderCounter);
    let swappedLegends = C.URLParams["swappedLegends"];
    let indexedVals = C.URLParams["indexedVals"];
    let isLines = C.URLParams["isLines"];
    let categories;
    let seriesArray;
    let yAxisTitle;
    let tooltipFunction;
    isLines = String(isLines);
    swappedLegends = String(swappedLegends);
    indexedVals = String(indexedVals);

    if (cats) {
      categories = cats;
    } else if (swappedLegends == "true" && C.swapAllowed) {
      C.currentCategoriesArray = C.csvSwappedChartCatArray;
    } else {
      C.currentCategoriesArray = C.csvChartCatArray;
    }

    if (!cats) {
      categories = C.currentCategoriesArray;
    }

    if (seriesArr) {
      seriesArray = seriesArr;
    } else if (swappedLegends == "true" && C.swapAllowed) {
      // create a new series Array based on current Chart series array, to modify view type, without losing original data
      C.currentSeriesArray = JSON.parse(JSON.stringify(C.csvSwappedChartSeriesArray));
    } else {
      // create a new series Array based on current Chart series array, to modify view type, without losing original data
      C.currentSeriesArray = JSON.parse(JSON.stringify(C.csvChartSeriesArray));
    }

    if (!seriesArr) {
      seriesArray = C.currentSeriesArray;
    }

    if (isLines == "true" && !seriesArr) {
      C.currentSeriesArray.forEach((series) => {
        if (series.type == "line") {
          series["type"] = "column";
          series["zIndex"] = 1;
        } else {
          series["type"] = "line";
          series["zIndex"] = 2;
        }
      });
    }

    if (indexedVals == "true") {
      yAxisTitle = '%';
      seriesArray.forEach(series => {
        const valArray = series.data;
        const indArray = [];
        valArray.forEach((val, i) => {
          const indexedVal = (val / valArray[0]) * 100;
          indArray.push(indexedVal);
        });
        series.data = indArray;
      });
      tooltipFunction = function () {
        const delta = this.y - 100;
        const prettyDelta = Math.round((delta + Number.EPSILON) * 100) / 100; // round to maximum of two digits after comma
        return `Δ ${prettyDelta}%`;
      };
    } else {
      yAxisTitle = C.currentChartyAxisTitle;
      tooltipFunction = function () {
        const axisStr = (this.point.series.yAxis.axisTitle) ? this.point.series.yAxis.axisTitle.textStr : '';
        return `${this.point.category}<br><span class="highcharts-color-${this.series.colorIndex}">\u25CF</span> ${this.series.name}: <b>${this.point.y.toFixed(1)} ${axisStr}</b>`;
      };
    }

    let chartOptions = {
      credits: {
        enabled: false,
      },
      legend: {
        enabled: false,
        symbolRadius: 0,
        useHTML: true,
        itemDistance: 40,
      },
      title: {
        text: '',
      },
      chart: {
        styledMode: true,
        height: "50%",
        type: "column",
        events: {
          load: function () {
            var chart = this;
            var legends;
            if (C.chartLegendSelector) {
              legends = [...document.querySelectorAll(`${C.chartLegendSelector}.active`)];
            }
            if (legends) {
              legends.forEach((legend) => {
                legend.innerHTML = "";
                legend.classList.add("outside-legend");
                chart.series.forEach(function (serie, i) {
                  var parent = document.createElement("div");
                  parent.classList.add("series-outside-legend-item");
                  parent.classList.add("series");
                  if (!serie.visible) {
                    parent.classList.add("inactive");
                  }
                  parent.setAttribute("data-index", i);
                  parent.setAttribute("data-colorIndex", serie.colorIndex);
                  parent.setAttribute("data-chartType", serie.type);
                  parent.innerHTML = serie.name;
                  legend.append(parent);
                });
              });
            }
          },
        },
      },
      yAxis: [{
        allowDecimals: true,
        showEmpty: false,
        maxPadding: 0.01,
        reversedStacks: false,
        title: {
          text: yAxisTitle,
        },
        softMin: 0,
      }, {
        allowDecimals: true,
        maxPadding: 0.01,
        reversedStacks: false,
        opposite: true,
        showEmpty: false,
        softMin: 0,
        title: {
          text: '%',
        },
      }],
      plotOptions: {
        series: {
          states: {
            hover: {
              halo: null,
              marker: {
                enabled: false,
              }
            }
          }
        },
        column: {
          stacking: 'normal',
        },
      },
      xAxis: {
        allowDecimals: true,
        // startOnTick: true,
        // endOnTick: true,
        categories: categories,
        labels: {
          useHTML: 'true',
          // autoRotation: false,
          // overflow: "allow"
          style: {
            textOverflow: 'none',
          },
        },
      },
      series: seriesArray,
      exporting: {
        chartOptions: {
          title: {
            text: C.currentChartName,
            align: 'left',
          },
          legend: {
            enabled: true
          }
        }
      },
      tooltip: {
        formatter: tooltipFunction,
      }
    };

    // console.log(chartOptions);
    C.currentHighchart = Highcharts.chart(C.chartContainerID, chartOptions);
    this.handleInactiveSeries();
  }

  handleSwapVisibility() {
    // if there are more than 1 series types displayed, hide the swap option, set "swapAllowed Variable"
    const types = [];
    C.currentHighchart.series.forEach(series => {
      if (series.visible) {
        if (types.includes(series.type)) {
          return;
        } else {
          types.push(series.type);
        }
      }
    });
    if (types.length > 1) {
      C.swappedLegendsBtn.forEach(btn => {
        btn.style.display = 'none';
        C.swapAllowed = false;
      });
    } else {
      C.swappedLegendsBtn.forEach(btn => {
        btn.style.display = 'flex';
        C.swapAllowed = true;
      });
    }
  }

  handleInactiveSeries() {
    const legendItems = [...document.querySelectorAll(C.chartLegendSelector + " .series-outside-legend-item")];
    let initialInactive = C.URLParams["inactiveSeries"];

    // if first draw and no URL value has been modified, build inactive series from given Data
    if (C.chartRenderCounter == 1 && initialInactive == '') {

      // build inactive Series Array of currently invisible indexes
      legendItems.forEach((item, i) => {
        const index = item.getAttribute("data-index");
        const d = C.currentHighchart.series[index];

        if (!d.visible) {
          C.currentInactiveSeriesArray.push(d.index);
        }
      });

      C.currentInactiveSeriesArray = C.currentInactiveSeriesArray.reduce(
        function (a, b) {
          if (a.indexOf(b) < 0) a.push(b);
          return a;
        },
        []
      );

      let inactives = C.currentInactiveSeriesArray.join("-");
      C.URLParams["inactiveSeries"] = inactives;
      C.updateURLParams(C.URLParams);

    } else {
      // this is what we do on chart updates or if there is URL parameter on first render
      if (initialInactive.length > 0) {
        C.currentInactiveSeriesArray = initialInactive.split("-");
      } else {
        C.currentInactiveSeriesArray = [];
      }

      // if series is initially hidden in data, make it visible so truly only the ones from URL Params get hidden
      C.currentHighchart.series.forEach((series, index) => {
        if (!series.visible) {
          series.setVisible(true);
        }
      });
      legendItems.forEach(item => {
        if (item.classList.contains('inactive')) {
          item.classList.remove('inactive');
        }
      });

      // hide series that are within inactive series array
      C.currentInactiveSeriesArray.forEach((hiddenIndex) => {
        let hInd = parseFloat(hiddenIndex);
        const d = C.currentHighchart.series[hInd];
        let currentItems = [...document.querySelectorAll('.series-outside-legend-item[data-index="' + hInd + '"]')];
        currentItems.forEach((item) => {
          item.classList.add("inactive");
        });
        if (d) {
          d.setVisible(false);
        }
      });
    }

    legendItems.forEach((item, i) => {
      item.addEventListener("click", (e) => {

        const index = item.getAttribute("data-index");
        const d = C.currentHighchart.series[index];
        let currentItems = [...document.querySelectorAll('.series-outside-legend-item[data-index="' + index + '"]')];
        currentItems.forEach((item) => {
          if (item.classList.contains("inactive")) {
            item.classList.remove("inactive");
          } else {
            item.classList.add("inactive");
          }
        });
        if (d.visible) {
          d.setVisible(false);
          C.currentInactiveSeriesArray.push(d.index);
        } else {
          d.setVisible(true);
          let getindex = C.currentInactiveSeriesArray.indexOf(d.index);
          C.currentInactiveSeriesArray.splice(getindex, 1);
        }

        C.currentInactiveSeriesArray = C.currentInactiveSeriesArray.reduce(
          function (a, b) {
            if (a.indexOf(b) < 0) a.push(b);
            return a;
          },
          []
        );

        let inactives = C.currentInactiveSeriesArray.join("-");

        C.URLParams["inactiveSeries"] = inactives;
        C.updateURLParams(C.URLParams);
        new ChartTableHandler();
        this.handleSwapVisibility();
      });
    });
  }

  handleInactiveCats() {
    let legends = [...document.querySelectorAll(`${C.chartCatContainerSelector}.active`)];
    let initialInactive = C.URLParams["inactiveCats"];

    legends.forEach((legend, i) => {
      legend.innerHTML = '';
      C.currentCategoriesArray.forEach((cat, i) => {
        const catToggle = document.createElement('div');
        catToggle.classList.add('category-toggle');
        catToggle.setAttribute('data-cat-index', i);
        catToggle.innerHTML = cat;
        legend.append(catToggle);
        catToggle.addEventListener("click", (e) => {

          let index = catToggle.getAttribute("data-cat-index");
          let catToggles = [...document.querySelectorAll('.category-toggle[data-cat-index="' + index + '"]')];
          this.toggleCategory(catToggles, true);
        });
      });
    });

    if (initialInactive != '' || C.currentInactiveCatsArray.length > 0) {
      C.currentInactiveCatsArray = initialInactive.split('-');
      C.currentInactiveCatsArray.forEach((hiddenIndex, i) => {
        let hInd = parseFloat(hiddenIndex);
        let catToggles = Array.prototype.slice.call(
          document.querySelectorAll(
            '.category-toggle[data-cat-index="' + hInd + '"]'
          )
        );

        let render = false;
        if (i == C.currentInactiveCatsArray.length - 1) {
          render = true; // makes sure chart render will only be triggered on last iteration
        }
        this.toggleCategory(catToggles, render);
      });
    }
  }

  toggleCategory(toggles, render) {
    let activeArray = [];

    toggles.forEach((toggle) => {
      Helper.toggleClass(toggle, "inactive");
      let parent = toggle.parentElement;
      Array.from(parent.children).forEach((cat) => {
        if (!Helper.hasClass(cat, "inactive")) {
          let ind = parseFloat(cat.getAttribute("data-cat-index"));
          activeArray.push(ind);
        }
      });
    });

    activeArray = activeArray.reduce(function (a, b) {
      if (a.indexOf(b) < 0) a.push(b);
      return a;
    }, []);

    let seriesData = JSON.parse(JSON.stringify(C.currentSeriesArray));
    let cats = JSON.parse(JSON.stringify(C.currentCategoriesArray));

    let catIndexes = [];
    cats.forEach((category, index) => {
      catIndexes.push(index);
    });

    let inactiveCats = catIndexes.filter((x) => !activeArray.includes(x));

    for (var i = inactiveCats.length - 1; i >= 0; i--) {
      seriesData.forEach((series) => {
        series.data.splice(inactiveCats[i], 1);
      });
      cats.splice(inactiveCats[i], 1);
    }

    if (render) {
      C.currentInactiveCatsArray = inactiveCats;
      this.renderChart(seriesData, cats);
      let inactiveCatString = C.currentInactiveCatsArray.join("-");
      C.URLParams["inactiveCats"] = inactiveCatString;
      C.updateURLParams(C.URLParams);
      new ChartTableHandler();
    }
  }
}

export default ChartDisplayHandler;
